import React from "react";
// Shared global classes still live here.
import "./ViewSignatureSamplePopupDynamic.scss";
import ViewSignatureSamplePopup, {
  IViewSignatureSamplePopupProps,
} from "./ViewSignatureSamplePopup";

// Same guide as ViewSignatureSamplePopup (shared modal); kept as a separate
// export so existing imports keep working.
const ViewSignatureSamplePopupDynamic = (props: IViewSignatureSamplePopupProps) => (
  <ViewSignatureSamplePopup {...props} titleId="sample-popup-dynamic-title" />
);

export default ViewSignatureSamplePopupDynamic;
